import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import AddListTemplateModalForm, {
  FormModel,
} from "./add-list-template-modal-form";
import { cast, FormValues } from "lib/form";
import { adminDoPostListTemplate } from "services/admin/list-template";
import { fetchListTemplates } from "stores/actions/list-templates";

interface AddListTemplateModalProps {
  onChange: () => Promise<void>;
  onClose: () => Promise<void>;
}

const AddListTemplateModal: FunctionComponent<AddListTemplateModalProps> = ({
  onChange,
  onClose,
}) => {
  const onSubmit = async (values: FormValues) => {
    const vals = cast<FormModel>(values);

    // signal changes to parent
    await adminDoPostListTemplate(vals.template);
    await onChange();

    // update state
    await fetchListTemplates();

    // finally, close the modal
    onClose();
  };

  return (
    <Modal title="Uusi luettelomalli">
      <AddListTemplateModalForm onClose={onClose} onSubmit={onSubmit} />
    </Modal>
  );
};

export default AddListTemplateModal;
